export const saveTextToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};
